export default __webpack_public_path__ + "media/b33d71ce08db15e73c9d1ff4b61d30f99cb04aa95ff3024522f5dc9834d49cf0.svg";